<template>
    <div class="modal fade modal-flex" id="getRewardedModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
        <div class="modal-dialog" style="width: 365px; max-width: 365px;">
            <div class="modal-content" style="padding-bottom: 15px;">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">{{ $t('lisa_web_claim_success') }}</h5>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                </div>
                <div class="modal-body">
                    <div class="welcome-back">
                        <!-- <img src="/themes/web/assets/images/achivement.svg" alt="" /> -->
                        <AppIcon :src="$store.state.treasure_icon_url" :size="150" />

                        <div class="welcome-back-content">
                            <!-- <span id = "congratulation_gem" class="modal-title" style="vertical-align: bottom;">+0</span> <i class="lisa-icon-gem-large-2" style="vertical-align: middle;"></i> -->
                            <span id = "congratulation_gem" class="modal-title" style="vertical-align: bottom; font-size: 40px; font-weight: 800;">+0</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-main-sm m-auto" @click="ok" style="padding: 8px 40px;">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppIcon from "@/components/common/AppIcon.vue";

export default {
  name: "GetRewardModal",
  components: { AppIcon },
  methods: {
    
    ok() {
        location.reload();
    }
    
  }  
}
</script>

<style scoped>
    .modal-content{
        background: url(/public/themes/ito/images/paper-flower.svg) no-repeat top;
        background-color: white;
        border-radius: 10px;
        height: 350px;
        width: 300px;
    }
    #staticBackdropLabel{
        font-weight: 900;
    }
</style>
